<template>
  <div class="back">
    <div class="back_image" ref="homePage">
      <!-- 入口按钮组合 -->
      <div class="btnList">
        <div class="btnList_item" @click="topage(1)">
          <img src="../../assets/images/padImage/indexBtn3.jpg" class="btnList_item_image" alt />
        </div>
        <div class="btnList_item" @click="topage(2)">
          <img src="../../assets/images/padImage/indexBtn2.jpg" class="btnList_item_image" alt />
        </div>
        <div class="btnList_item" @click="topage(3)">
          <img src="../../assets/images/padImage/indexBtn1.jpg" class="btnList_item_image" alt />
        </div>
      </div>
      <div class="btnList_item2">
        <img src="../../assets/images/padImage/zonghePad.png" class="btnList_item_image" alt />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  created() {},
  data() {
    return {
      clientHeight: ""
    };
  },
  mounted() {
    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}`; //document.body.clientWidth;
    //console.log(self.clientHeight);
    window.onresize = function temp() {
      this.clientHeight = `${document.documentElement.clientHeight}`;
    };
  },
  watch: {
    // 如果 `clientHeight` 发生改变，这个函数就会运行
    clientHeight: function() {
      this.changeFixed(this.clientHeight);
    }
  },
  methods: {
    changeFixed(clientHeight) {
      //动态修改样式
      console.log(clientHeight);
      this.$refs.homePage.style.height = clientHeight + "px";
    },
    topage(i) {
      if (i == 1) {
        this.$router.push({ path: "/pad_video" });
      } else if (i == 2) {
        this.$router.push({ path: "/pad_ppt" });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.back_image {
  width: 100%;
  background-image: url("../../assets/images/padImage/indexBacGround.jpg");
  background-size: 100% 100%;
}
.btnList {
  width: 80%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding-top: 100px;
}
.btnList_item {
  width: 30%;
  height: 200px;
}
.btnList_item2{
  width: 100%;
  height: 50px;
  margin-top: 30px;
}
.btnList_item_image {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/pad/pad_index.vue